import { combineReducers } from 'redux';

import alert from './alert';
import loader from './loader';
import breadcrumb from './breadcrumb';

import auth from './auth';
import dashboard from './dashboard';
import configuracion from './configuracion';
import membresias from './membresias';
import paquetes from './paquetes';
import citas from './citas';

export default combineReducers({
    alert, loader, breadcrumb, auth, dashboard, configuracion, membresias, paquetes, citas
});